import { graphql } from "react-relay";

export const DISCOUNT_ACTION_FRAGMENT = graphql`
	fragment discountCodeDownloadCsvButton_DiscountActionFragment on DiscountAction {
		discountCodesCSV
	}
`;
